import { Typography } from '@mui/material';
import sislogo from '../images/SIS_Logo.svg';

export const LayoutTopAppBarLeft = () => {
  return (
    <>
      <img src={sislogo} alt="sislogo" style={{ height: '40px', paddingRight: '10px' }} />
      <Typography variant="h6" noWrap component="div">
        Library Samples
      </Typography>
    </>
  )
}
